import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DomicilioSecundario, Usuario } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

class DatosEmail {
  destinatario: string;
  cuerpo: string;
  asunto: string;
}

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  url = environment.url2 + '/usuario';
  url2 = environment.url2 + '/usuarioRolSociedad';
  url3 = environment.url2 + '/envioMail';
  url4 = environment.url2 + '/domicilioSecundarios';
  constructor(private http: HttpClient) {}

  count() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/count`, { headers }).pipe( map( data => data));
    }

  getAll(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }`, { headers }).pipe( map( data => data));
  }

  add(usuario: Usuario) {
    let body = JSON.stringify(usuario);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    // .append('Access-Control-Allow-Origin', environment.urlLocal);
    return this.http.post(`${ this.url }/add`, body, { headers }).pipe( map( data => data));
  }

  update(usuario: Usuario) {
    let body = JSON.stringify(usuario);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.put(`${ this.url }/update`, body, { headers }).pipe( map( data => data));
  }

  find(rfcUsuario: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'aplication/json')
    // .append('Access-Control-Allow-Origin', environment.urlLocal);
    let consult = this.http.get(`${ this.url }/find/${ rfcUsuario }`, { headers }).pipe( map( data => data));
    return consult;
  }

  delete(idUsr: String) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.delete(`${ this.url }/delete/${ idUsr }`,  { headers }).pipe( map( data => data));
  }

  ///////////////////SERVICIOS DE USUARIO ROL SOCIEDAD

  addRelacion(usrRS: any) {
    let body = JSON.stringify(usrRS);
    console.log(body);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url2 }/add`, body, { headers }).pipe( map( data => data));
  }

  ///////////////////
  enviomail(email: DatosEmail) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    // .append('Access-Control-Allow-Origin', environment.urlLocal);
    console.log('casa');
    console.log(this.url3 );
    return this.http.post(`${ this.url3 }/mail`, email , { headers }).pipe( map( data => data));
  }

  //////DOMICILIO SECUNDARIO//////////
  getAllDomicilioSecundario(rfcUsuario: string) {
    console.log('METODO');
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url4 }/all/${ rfcUsuario }`, { headers }).pipe( map( data => data));
  }

  addDomicilioSecundario(domicilio: DomicilioSecundario) {
    let body = JSON.stringify(domicilio);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url4 }/add`, body, { headers }).pipe( map( data => data));
  }

  deleteDomicilioSecundario(id: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.delete(`${ this.url4 }/delete/${ id }`,  { headers }).pipe( map( data => data));
  }

}
